import { render, staticRenderFns } from "./QuestionsEditor.vue?vue&type=template&id=7aa37a92&scoped=true"
import script from "./QuestionsEditor.vue?vue&type=script&lang=js"
export * from "./QuestionsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa37a92",
  null
  
)

export default component.exports